// Every entry point into content-manager from outside it needs to
// force a full reload instead of a normal client-side navigation.
export const needsFullReloadInto = (appId, currentPathname) =>
  appId === "content-manager" && !currentPathname.includes("content-manager");
